import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from '../api/axiosInstance';

function getLocalDateTimeString() {
    const now = new Date();
    const offset = now.getTimezoneOffset();
    const localDate = new Date(now.getTime() - offset * 60000);
    return localDate.toISOString().slice(0, 16); // 格式為 yyyy-MM-ddTHH:mm
}

function BloodSugarForm() {
    const navigate = useNavigate();
    const [userName, setUserName] = useState("訪客");
    const [form, setForm] = useState({
        glucose: '',
        notes: '',
        type: 0, // 0: 空腹, 1: 飯後
        recordedAt: getLocalDateTimeString(),
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const token = localStorage.getItem('token');
        if (!token) return alert('請先登入');

        const response = await axios.post('/api/BloodSugar', form, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });

        if (response.status === 200) {
            alert('新增成功');
            navigate("/blood-sugar/history");
        } else {
            alert('新增失敗');
        }
    };

    useEffect(() => {
        document.title = "新增血糖紀錄 - {userName}";

        try {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user?.name) {
                setUserName(user.name);
            }
        } catch (err) {
            console.error("讀取 user 發生錯誤", err);
        }
    }, []);

    return (
        <div className="container mt-4">
            <h2 className="mb-3">新增血糖紀錄 - {userName}</h2>

            <div className="mb-3">
                <button className="btn btn-success me-2" onClick={() => navigate("/blood-sugar/history")}>
                    血糖歷史記錄
                </button>
                <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
                    回到目錄
                </button>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">血糖值</label>
                    <input
                        type="tel"
                        inputMode="numeric"
                        className="form-control"
                        name="glucose"
                        value={form.glucose}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">類型</label>
                    <select
                        className="form-control"
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                        required
                    >
                        <option value={0}>空腹</option>
                        <option value={1}>飯後</option>
                    </select>
                </div>

                <div className="mb-3">
                    <label className="form-label">備註</label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="我昨天吃了…"
                        name="notes"
                        value={form.notes}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-3">
                    <label className="form-label">紀錄時間</label>
                    <input
                        type="datetime-local"
                        className="form-control"
                        name="recordedAt"
                        value={form.recordedAt}
                        onChange={handleChange}
                        required
                    />
                </div>

                <button type="submit" className="btn btn-primary">送出</button>
            </form>
        </div>
    );
}

export default BloodSugarForm;
